document.addEventListener("DOMContentLoaded", function () {
  const searchFilterBtn = document.querySelectorAll('.search-filter__btn');
  const searchResultBlocks = document.querySelectorAll('.search-result-block');
  const searchResult = document.querySelector('.search-result');
  let isAnimateSearch = false;

  function clearActiveClases() {
    searchFilterBtn.forEach((i) => {
      i.classList.remove('btn_active');
    });
    searchResultBlocks.forEach((i) => {
      i.classList.remove('search-result-block_active');
    });
  }

  function getNextActiveResultBlock(id) {
    let result = null;

    searchResultBlocks.forEach((i) => {
      if (i.id === id) {
        result = i;
      }
    });

    return result;
  }

  function setActiveResultBlock(id) {
    searchResultBlocks.forEach((i) => {
      if (i.id === id) {
        i.classList.add('search-result-block_active');
      }
    });
  }

  function setIsAnimateSearch(isAnimate) {
    isAnimateSearch = isAnimate;
  }

  function animateCloseOpenResultBlock(currentBlock, nextBlock) {
    const SRTimeline = gsap.timeline();
    SRTimeline
      .call(setIsAnimateSearch, [true])
      .to(currentBlock, {
        duration: 0.5,
        css: {
          height: '0',
          opacity: '0',
          pointerEvents: 'none',
        }
      })
      .to(nextBlock, {
        duration: 0.7,
        css: {
          height: 'auto',
          opacity: '1',
          pointerEvents: 'auto',
        }
      })
      .call(setIsAnimateSearch, [false]);
  }
  
  function switchSearchFilter({ target }) {
    if (!isAnimateSearch) {
      const id = target.getAttribute('data-id');
      const nextBlock = getNextActiveResultBlock(id);
      const currentBlock = searchResult.querySelector('.search-result-block_active');

      clearActiveClases();

      target.classList.add('btn_active');
      setActiveResultBlock(id);

      animateCloseOpenResultBlock(currentBlock, nextBlock);
    }
  }

  searchFilterBtn.forEach((i) => {
    i.addEventListener('click', switchSearchFilter);
  });
});